"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_client_1 = require("./base.client");
const token_storage_1 = require("../token.storage");
const auth_client_1 = require("./auth.client");
const errors_1 = require("../errors");
const auth_v2_client_1 = require("./auth.v2.client");
const models_1 = require("../models");
class AuthenticatedClient extends base_client_1.BaseClient {
    executeCall(method, url, data, opts) {
        const _super = Object.create(null, {
            executeCall: { get: () => super.executeCall }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const config = this.getConfig();
            const requestOpts = Object.assign(Object.assign({ headers: {} }, opts), { throwOnError: false });
            const jwtToken = config.jwtToken || token_storage_1.TokenStorage.get();
            if (!jwtToken) {
                throw new Error('JWT token is required.');
            }
            requestOpts.headers.authorization = `Bearer ${jwtToken}`;
            const response = yield _super.executeCall.call(this, method, url, data, requestOpts);
            if (response.success) {
                return response;
            }
            const errorResponse = response;
            if (errorResponse.errorCode === 'JWT_EXPIRED') {
                requestOpts.throwOnError = opts && opts.throwOnError;
                try {
                    let authClient, refreshResult;
                    const tokenVersion = models_1.TokenBody.getBody(jwtToken).version;
                    if (tokenVersion === '3') {
                        authClient = new auth_v2_client_1.AuthV2Client(config);
                        const { accessToken } = yield authClient.refreshToken(jwtToken);
                        refreshResult = accessToken;
                    }
                    else {
                        authClient = new auth_client_1.AuthClient(config);
                        refreshResult = yield authClient.refreshToken(jwtToken, config.refreshTokenId);
                    }
                    this.configurationProvider.setRefreshedToken(refreshResult);
                    token_storage_1.TokenStorage.store(refreshResult);
                    requestOpts.headers.authorization = `Bearer ${refreshResult}`;
                    return yield _super.executeCall.call(this, method, url, data, requestOpts);
                }
                catch (e) {
                    throw new errors_1.ClientError({
                        success: false,
                        errorCode: 'TOKEN_REFRESH_ERROR',
                        errorMessage: 'Refresh error',
                        payload: e,
                    });
                }
            }
            else if (opts && opts.throwOnError) {
                throw new errors_1.ClientError(response);
            }
            if (opts && !!opts.throwOnError) {
                throw new errors_1.ClientError(response);
            }
            return response;
        });
    }
}
exports.AuthenticatedClient = AuthenticatedClient;
//# sourceMappingURL=authenticated.client.js.map